<script setup lang="ts">
import { Check } from 'lucide-vue-next'
import { selectedOrder } from '@/event/account/dashboard/history/selectedOrder'
import { showSelectedOrder } from '@/event/account/dashboard/history/showSelectedOrder'
import { changeInvoiceNo } from '@/utils/account/dashboard/changeInvoiceNo'
import { statusOrder } from '@/utils/order/statusOrder'
import { formatPrice } from '@/event/locale'

function toggleModalShowOrderHappy() {
    showSelectedOrder.value = false
    document.body.style.overflow = 'auto'

    setTimeout(() => {
        selectedOrder.value = undefined
    }, 300)
}
const getPaidClass = (order: any) => {
    return order.payment_status === 'orderPaid' ? 'success' : 'error'
}
</script>

<template>
    <section class="section-modal-show-order-happy" v-if="selectedOrder !== undefined">
        <section
            class="section-overlay-modal-show-order-happy"
            @click="toggleModalShowOrderHappy()"
        ></section>

        <transition
            enter-active-class="transition-all duration-300 ease-in-out"
            enter-from-class="opacity-0 -translate-y-4"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition-all duration-300 ease-in-out"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-4"
        >
            <section
                class="section-content-modal-show-order-happy"
                v-if="showSelectedOrder"
            >
                <div
                    class="header-show-modal-order-happy"
                    v-if="changeInvoiceNo(selectedOrder?.invoice_no) !== ' Annulée'"
                >
                    {{ $t('order') }} n° {{ changeInvoiceNo(selectedOrder?.invoice_no) }}
                </div>
                <div v-else class="header-show-modal-order-happy">
                    {{ $t('order') }} — {{ $t('cancelled') }}
                </div>

                <section class="section-content-internal-modal-show-order-happy">
                    <section class="section-infos-modal-show-order-happy">
                        <div class="div-first-content-modal-show-order-happy">
                            <p>{{ selectedOrder.date_added }}</p>
                            <p class="text-modal-order-happy">
                                {{ $t('total') }} :
                                <span class="text-price-modal-happy">{{
                                    formatPrice(selectedOrder.total)
                                }}</span>
                            </p>
                        </div>
                        <div class="div-second-content-modal-show-order-happy">
                            <p class="text-modal-order-happy">
                                {{ 'Id° : ' + selectedOrder.order_id }}
                            </p>
                            <p
                                v-if="
                                    selectedOrder.shipping_price &&
                                    parseFloat(selectedOrder.shipping_price) !== 0.0
                                "
                                class="text-modal-order-happy"
                            >
                                {{ $t('deliveryFee') }} :
                                <span class="text-price-modal-happy">
                                    {{ formatPrice(parseFloat(selectedOrder.shipping_price)) }}
                                </span>
                            </p>
                        </div>

                        <div class="div-third-content-modal-show-order-happy">
                            <p
                                class="text-modal-order-happy"
                                v-if="selectedOrder.payment_method === 'Non Payé'"
                            >
                                {{ $t('paymentMethod') }} :
                                <span class="font-normal">
                                    {{ selectedOrder.payment_method }}</span
                                >
                            </p>

                            <p class="text-modal-order-happy">
                                {{ $t('pickupMethod') }} :
                                <span class="font-normal">
                                    {{ selectedOrder.shipping_method }}</span
                                >
                            </p>
                        </div>

                        <div class="div-second-content-modal-show-order-happy">
                            <p :class="getPaidClass(selectedOrder)">
                                {{ $t(selectedOrder.payment_status) }}
                            </p>
                            <p
                                class="text-modal-order-happy"
                                :class="statusOrder(selectedOrder.order_status_id).class"
                            >
                                {{ selectedOrder.order_status_name }}
                            </p>
                        </div>
                    </section>
                    <section class="section-product-modal-show-order-happy">
                        <div
                            v-for="(product, i) in selectedOrder.order_products"
                            :key="i"
                            class="div-product-modal-show-order-happy"
                            :class="{
                                'border-b happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light':
                                    i < selectedOrder.order_products.length - 1
                            }"
                        >
                            <div class="div-infos-product-modal-show-order-happy">
                                <div class="flex items-center">
                                    <img
                                        v-if="product.image"
                                        :src="product.image"
                                        alt="Image du produit"
                                        class="img-modal-show-order-happy"
                                    />
                                    <div class="flex items-start flex-col pl-3">
                                        <p class="text-modal-order-happy">
                                            {{ product.name }}
                                        </p>
                                        <p
                                            class="text-sm font-semibold whitespace-normal"
                                        >
                                            {{ $t('quantity') }} :
                                            <span class="font-normal">{{
                                                product.quantity
                                            }}</span>
                                        </p>
                                    </div>
                                </div>
                                <p class="text-price-modal-happy font-semibold pl-3">
                                    {{ formatPrice(parseFloat(product.price)) }}
                                </p>
                            </div>

                            <div
                                class="div-options-product-modal-show-order-happy"
                                v-if="product.order_options.length > 0"
                            >
                                <div
                                    v-for="(option, index) in product.order_options"
                                    :key="index"
                                    class="option-modal-show-order-happy"
                                >
                                    <Check
                                        class="svg-option-order-happy"
                                        :size="16"
                                        :stroke-width="2"
                                    />
                                    <p
                                        class="flex flex-wrap whitespace-break-spaces"
                                        v-if="option.values"
                                    >
                                        {{ option.name }} :
                                        <span
                                            v-for="(value, _iv) in option.values"
                                            :key="value"
                                        >
                                            {{ value
                                            }}<span v-if="_iv < option.values.length - 1"
                                                >{{ ', ' }}
                                            </span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-modal-show-order-happy {
    @apply fixed inset-0 h-full w-full z-30 flex justify-center;
}

.section-overlay-modal-show-order-happy {
    /* refactored — bg-t-text dark temalarda near-white olduğu için dim niyeti
       ters çalışıyordu (krem wash üretiyordu). bg-black/30 ile tüm temalarda
       doğru dim elde ediyoruz. */
    @apply absolute w-full h-full bg-black/30;
}

.section-content-modal-show-order-happy {
    /* refactored: multi-theme border/bg/text/shadow -> semantic tokens */
    @apply min-w-[19rem] max-w-[36rem] mx-3 mt-32 rounded-md shadow flex-col border-2 items-center;
    @apply relative z-10 max-h-[80vh] h-fit overflow-hidden;
    @apply bg-t-card text-t-text border-t-accent shadow-t-border;
    @apply happy-purple-gradient:bg-gradient-to-t happy-purple-gradient:to-bg-purple-dark happy-purple-gradient:from-bg-purple-light;
}
.header-show-modal-order-happy {
    /* refactored: multi-theme bg/text -> t-accent/t-on-accent */
    @apply w-full h-12 flex pl-4 items-center text-lg font-bold bg-t-accent text-t-on-accent;
}
.section-content-internal-modal-show-order-happy {
    @apply w-full max-h-[65vh] overflow-y-auto;
    @apply flex flex-col items-center;

    min-height: auto;
}

.section-infos-modal-show-order-happy {
    /* refactored: border -> border-t-border */
    @apply w-full flex flex-col p-3 border-b border-t-border;
}

.div-second-content-modal-show-order-happy {
    @apply w-full flex items-center justify-between;
}
.div-third-content-modal-show-order-happy {
    @apply w-full flex flex-col items-start text-sm;
}

.div-first-content-modal-show-order-happy {
    @apply w-full flex justify-between flex-wrap;
}

.text-modal-order-happy {
    @apply font-semibold;
}
.text-price-modal-happy {
    /* refactored: multi-theme text -> text-t-accent */
    @apply text-t-accent;
}
.wait-class {
    @apply bg-border-red-happy-light text-bg-happy-light py-1 px-2 rounded text-sm min-w-24 text-center;
}

.preparation-class {
    @apply bg-bleu-happy py-1 px-2 rounded text-sm text-bg-happy-light  min-w-24 text-center;
}

.approve-class {
    @apply bg-button-yellow-happy-light py-1 px-2 rounded text-sm min-w-24 text-center text-text-dark-happy-light;
}

.ready-class {
    @apply bg-green-happy py-1 px-2 rounded text-sm min-w-24 text-center text-text-dark-happy-light;
}

.delivery-class {
    @apply bg-gray-500 text-bg-happy-light py-1 px-2 rounded text-sm min-w-24 text-center;
}
.success {
    @apply font-semibold text-green-happy;
    @apply happy-light:text-green-dark-happy;
    @apply happy-urban-light-red:text-green-dark-happy;
    @apply happy-orange-light:text-green-dark-happy;
    @apply happy-fresh-mint:text-green-dark-happy;
    @apply happy-bee-light:text-green-dark-happy;
    @apply happy-earth-stone:text-green-dark-happy;
    @apply happy-scorched-earth:text-green-dark-happy;
    @apply happy-sand-sky:text-green-dark-happy;
    @apply happy-gray-sand:text-green-dark-happy;
}
.error {
    @apply font-semibold text-border-red-happy-light;
    @apply happy-earth-stone:text-urban-red-dark;
    @apply happy-scorched-earth:text-scorched-earth-red;
    @apply happy-purple-gradient:text-urban-dark;
}

.section-product-modal-show-order-happy {
    @apply max-w-full flex flex-col flex-wrap gap-2;
}

.div-product-modal-show-order-happy {
    @apply max-w-full flex flex-col flex-wrap whitespace-pre-wrap break-all px-3 py-2;
}

.div-infos-product-modal-show-order-happy {
    @apply flex items-center justify-between flex-wrap;
}
.img-modal-show-order-happy {
    @apply w-14 h-14 object-contain rounded-md;
}
.div-options-product-modal-show-order-happy {
    @apply w-full flex flex-col;
}
.option-modal-show-order-happy {
    @apply w-full flex gap-1 items-start;
    @apply flex-wrap;
}
.svg-option-order-happy {
    /* refactored: lucide uses currentColor */
    @apply w-4 h-4 mt-1 text-t-text;
}
</style>
